export default __webpack_public_path__ + "static/media/Slider-2.5bc77599.jpg";